import React, { PropsWithChildren } from "react";
import "./SuccessMessage.scss";
import Button from "../Button/Button";

const SuccessMessage: React.FC<PropsWithChildren<SuccessMessageProps>> = ({
  title,
  buttonText,
  children,
}) => {
  return (
    <div className="password-reset-success">
      <h3 className="password-reset-success__title">{title}</h3>
      <div className="password-reset-success__content">{children}</div>
      <div className="password-reset-success__link">
        <Button as={"a"} href={"/login"} width={"fullWidthMobile"}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export type SuccessMessageProps = {
  title: string;
  buttonText: string;
};

export default SuccessMessage;
